import React from 'react';

export const NoBorder = () => (
    <>
        <rect x="2" y="2" width="20" height="20" rx="1" fill="white" stroke="black" strokeLinejoin="round"/>
    </>
);